import { Component } from 'react';
import React from 'react';
import { Button, Card, CardBody,CardTitle ,CardText, ListGroup, ListGroupItem, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import api from '../api/dataSource';
import { Loading } from './Loading';

const MySwal = withReactContent(Swal)

const ORDEN = [
  { id: '1015517026', orden: 1 },  // CUMBRE S.A.
  { id: '1028433025', orden: 2 },  // UNIVERSAL LTDA.
  { id: '1030361028', orden: 3 },  // VASLEC INTERNACIONAL S.R.L.
  { id: '126327023', orden: 4 },   // ARG S.A.
  { id: '167220025', orden: 5 },   // IMEX GROUP SRL (ID: 167220025 en JSON)
  { id: '373174025', orden: 6 },   // MCAMAZONAS SRL
  { id: '1014405022', orden: 7 },  // INTERCOMEX S.A.
  { id: '1012755028', orden: 8 },  // OLIVERA Y CIA LTDA
  { id: '1019523025', orden: 9 },  // R & S S.R.L
  { id: '373079022', orden: 10 },  // ANJOS ASOCIADOS SRL
  { id: '372196026', orden: 11 },  // URUBO SRL
  { id: '372477020', orden: 12 },  // PLUSCOMEXT SRL
  { id: '6304881011', orden: 13 }, // ARGOSS
  { id: '373193028', orden: 14 },  // CRUZBEN SRL
  { id: '373473027', orden: 15 },  // NEOCOMEX SRL
  { id: '372199022', orden: 16 },  // MUNDOCOMEX SRL
  { id: '519764021', orden: 17 },  // A&E JACACORP S.R.L.
  { id: '314802023', orden: 18 },  // ADUANOVA SRL
  { id: '486479026', orden: 19 },  // SUPRACOMEX S.R.L.
  { id: '151240026', orden: 20 },  // UNZUETA LTDA
  { id: '374676023', orden: 21 },  // VICOMEX S.R.L (ID: 374676023 en JSON)
  { id: '375482020', orden: 22 },  // TRADECRUZ SRL
  { id: '182622025', orden: 23 },  // FG LOGISTIC SRL
  { id: '375561027', orden: 24 },  // DEUGARTE SRL
  { id: '388647020', orden: 25 },  // GRUPO INTERCONTINENTALCOMEX
  { id: '168920024', orden: 26 },  // TAMENGO S.R.L.
  { id: '161068022', orden: 27 },  // QUIROGA QUIROGA CRESPO S.R.L.
  { id: '523386028', orden: 28 },  // SAICORP S.R.L.
  { id: '373099027', orden: 29 },  // MEGACOMEX SRL
  { id: '373674029', orden: 30 },  // HCLLANOS GRUPO SRL
  { id: '374689028', orden: 31 },  // LOGADEX S.R.L.
  { id: '374888022', orden: 32 },  // LUDASA SRL
  { id: '523064023', orden: 33 },  // MASTERCOMEX
  { id: '519066027', orden: 34 },  // ADAFALABELLA S.R.L.
  { id: '381872026', orden: 35 },  // X ZONACOMEX SRL
  { id: '372076020', orden: 36 },  // # ARANCEL SRL
  { id: '519779025', orden: 37 },  // GLOBALBOL S.R.L.
  { id: '1013295024', orden: 38 }, // COMINTER S.R.L.
  { id: '374941024', orden: 39 },  // ARIMEXI SRL
  { id: '373194023', orden: 40 },  // SAMED SRL
  { id: '1021505024', orden: 41 }, // AGENAL ANTONIO YUTRONIC S.A.
  { id: '2726247018', orden: 42 }, // PIRAMIDE S.R.L. (PIRAME en Excel)
  { id: '1007931026', orden: 43 }, // BRUSECO
  { id: '494994023', orden: 44 },  // CONTINENTAL GROUP SRL
  { id: '1014861022', orden: 45 }, // ACHES S.R.L.
  { id: '157702021', orden: 46 },  // RCB S.R.L.
  { id: '373600023', orden: 47 }, // SANTA CRUZ DISPATCHERS SRL
  { id: '159698025', orden: 48 }, // XIMPLE SRL
  { id: '373275021', orden: 49 }, // AMERICANCOM SRL
  { id: '372466025', orden: 50 }, // CATEDRAL SRL
];

function CardAgencia({agencias,mostrarAgencia}){

  let getDataAgencia = (agencia) => {
    let uri = `CD2/Agencias/ObtenerAgenciaParaPagina?AgenciaID=${agencia.id}&jwt_off=1`;
    let uriDocumentos = `CD2/Agencias/ListarDocumentosAgencia?AgenciaID=${agencia.id}&jwt_off=1`;
    MySwal.showLoading();
    api.get(uri).then(data => {
      api.get(uriDocumentos).then(dataDoc => {
        mostrarAgencia({data,dataDoc,agencia});
      }).catch(error => {
        console.log(error);
      }).finally(()=> {
        MySwal.close();
      });
    }).catch(error => {
      console.log(error);
      MySwal.close();
    });
  }

  return agencias.map((agencia) => {
    return (
      <div className="col-md-4">
        <div className="card-agencia rowx" onClick={ () => getDataAgencia(agencia) }>
          <div style={{flex: '70%'}}>
            <h6><strong>{agencia.titulo}</strong></h6>
            {
              !!agencia.representante ?
                <p><small>{agencia.representante}</small></p> :
                ""
            }
          </div>
          <div style={{flex: '30%'}}>
            <img className="img-fluid" src={agencia.imagen} alt="card image"/>
          </div>
        </div>
      </div>
    )
  });
}


class Agencias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agencias: [],
      agenciasFilter: [],
      filtro: '',
      modalShow: false,
      agency:{
        CD2agenciaID: '',
        DireccionLaboral: '',
        Email1: '',
        Estado: '',
        Fax: '',
        TelefonoFijo: '',
        TipoSociedad: '',
        TituloReferencial: '',
        logo: '',
        foto: ''
      },
      loading:false
    };

    this.getData = this.getData.bind(this);
    this.filterData = this.filterData.bind(this);
    this.openModal = this.openModal.bind(this);
    this.cerrarModal = this.cerrarModal.bind(this);
  }

  getData(){
    this.setState({ loading: true });
    let uri = 'CD2/Agencias/ListarAgenciaSimpleMultimedia?jwt_off=1';
    api.get(uri).then(data => {
      let eldata = [];
      data.forEach((item, i) => {
        if(item.EstadoCD2estadoAgenciaID==="ACT"){
          let doc = item.Documento;
          let imagen = "";
          if(!!doc){
            if(doc.NavCD2documentoAgenciaMultimedias.length > 0){
              imagen = `https://crdascz.siga.com.bo/api/SYS/SHARED/ReturnFileArchivo?FileArchivo=${doc.NavCD2documentoAgenciaMultimedias[0].FileArchivo}&jwt_off=1`;
            }else{
              imagen = "http://crdascz.com/CRDASCZ/wp-content/uploads/2021/01/sinfoto.jpg";
            }
          }else{
            imagen = "http://crdascz.com/CRDASCZ/wp-content/uploads/2021/01/sinfoto.jpg";
          }
          if(item.TituloReferencial!=="DESPACHANTE DE ADUANA"){
            eldata.push({
              id:item.CD2agenciaID,
              titulo: item.TituloReferencial,
              contacto: item.NombrePersonaContacto,
              correo: item.Correo,
              representante: item.RepresentanteActual,
              orden: 0,
              imagen
            })
          }
        }
      });
      let indice = 30
      eldata.forEach((x) => {
        let nuevoInd = ORDEN.findIndex(y => y.id === x.id)
        if (nuevoInd != -1) {
          x.orden = ORDEN[nuevoInd].orden
        } else {
          x.orden = indice++
        }
      })
      eldata.sort((p1, p2) => p1.orden - p2.orden)

      this.setState({
        agencias: eldata,
        agenciasFilter: eldata,
        loading: false
      });
    }).catch(error => {
      this.setState({ loading: false });
      console.log(error);
    });
  }

  componentDidMount(){
    this.getData();
  }

  filterData(valor){
    const filtrado = this.state.agencias.filter(e => e.titulo.toLowerCase().includes(valor.toLowerCase()));
    if(!filtrado){
      filtrado=this.state.agencias;
    }
    this.setState({ filtro:valor, agenciasFilter: filtrado })
  }

  openModal = (datos) => {
    let dx = datos.data;
    let d = dx.Item1;
    let fotox = dx.Item2;
    let doc = datos.dataDoc;
    let agencia = datos.agencia;
    let logo = "";
    let foto = "";
    if(doc.length !== 0){
      let f = doc.find(x=>x.TipoDocCD2tipoDocumentoAgenciaID === 'LOG');
      if(!!f){
        let ff = f.NavCD2documentoAgenciaMultimedias[0];
        logo = ff.FileArchivo;
      }
    }
    if(!!fotox){
      foto = fotox.FileArchivo;
    }
    this.setState({
      modalShow: true,
      agency:{
        CD2agenciaID: d.CD2agenciaID,
        DireccionLaboral: d.DireccionLaboral,
        Email1: d.Email1,
        Estado: d.EstadoCD2estadoAgencia.EstadoAgencia,
        Fax: d.Fax,
        TelefonoFijo: d.TelefonoFijo,
        TipoSociedad: d.TipoSociedadCD2tipoSociedadJuridicaID,
        TituloReferencial: d.TituloReferencial,
        altaSistema: d._CreatedAt.slice(0,10),
        SitioWeb: d.SitioWeb,
        NombrePersonaContacto: d.NombrePersonaContacto,
        FechaAniversario: d.FechaAniversario,
        representante: agencia.representante,
        logo,
        foto
      }
    });
  }

  cerrarModal = () => {
    this.setState({
      modalShow: false
    });
  }

  render(){
    let imagen;
    let foto;
    if(this.state.agency.logo !== ""){
      imagen = <img className=" img-fluid" src={`https://crdascz.siga.com.bo/api/SYS/SHARED/ReturnFileArchivo?FileArchivo=${this.state.agency.logo}&jwt_off=1`} alt="card image"/>;
    }else{
      imagen = <img className=" img-fluid" src="http://crdascz.com/CRDASCZ/wp-content/uploads/2021/01/sinfoto.jpg" alt="card image"/>;
    }

    if(this.state.agency.foto !== ""){
      foto = <img className=" img-fluid" src={`https://crdascz.siga.com.bo/api/SYS/SHARED/ReturnFileArchivo?FileArchivo=${this.state.agency.foto}&jwt_off=1`} alt="card image"/>;
    }else{
      foto = "";
    }

    return (
      <div className="container" style={{paddingTop: '100px'}}>
        <div className="row">
          <div className="col-12">
            <Card>
                <CardBody className="text-center mt-4">
                    <CardTitle>
                      <img src="/img/agencia.png"/>
                      <h1>Lista de Agencias</h1>
                    </CardTitle>
                    <CardText>
                      <div className="input-group mb-3">
                          <div className="input-group-prepend">
                            <img src="/img/search.png" className="icon-image"/>
                          </div>
                          <input type="text" value={ this.filtro } className="form-control input-lg" onChange={e => this.filterData(e.target.value)}/>
                      </div>
                    </CardText>
                </CardBody>
            </Card>
          </div>
        </div>
        <div className="row">
        {
          this.state.loading ?
            <Loading></Loading> :
            <CardAgencia agencias={this.state.agenciasFilter} mostrarAgencia={(data) => this.openModal(data)}></CardAgencia>
        }
        </div>

        <Modal isOpen={this.state.modalShow} size="lg">
          <ModalHeader className="cardHeader" toggle={this.cerrarModal}>{this.state.agency.TituloReferencial}</ModalHeader>
          <ModalBody className="imagenBackground">
            <div className="row">
              <div className="col-sm-12 col-md-9">
                <Card body>
                  <Table hover size="sm" bordered>
                    <tbody>
                    {
                      !!this.state.agency.Estado ?
                        <tr>
                          <th scope="row">
                          <i className="fa fa-address-card-o"></i>{' '}
                          Estado
                          </th>
                          <td>
                            <div>
                              {this.state.agency.Estado}
                            </div>
                          </td>
                        </tr>
                      : ""
                    }
                    {
                      !!this.state.agency.DireccionLaboral ?
                        <tr>
                          <th scope="row" width="30%">
                            <i className="fa fa-map-marker"></i>{' '}
                            Dirección Laboral
                          </th>
                          <td>{this.state.agency.DireccionLaboral}</td>
                        </tr>
                        : ""
                    }
                    {
                      !!this.state.agency.Email1 ?
                        <tr>
                          <th scope="row">
                            <i className="fa fa-envelope-o"></i>{' '}
                            Correo Electrónico
                          </th>
                          <td>
                            {this.state.agency.Email1}
                          </td>
                        </tr>
                        : ""
                    }
                    {
                      !!this.state.agency.TelefonoFijo ?
                        <tr>
                          <th scope="row">
                            <i className="fa fa-mobile-phone"></i>{' '}
                            Teléfono
                          </th>
                          <td>{this.state.agency.TelefonoFijo}</td>
                        </tr>
                        : ""
                    }
                    {
                      !!this.state.agency.Fax ?
                        <tr>
                          <th scope="row">
                            <i className="fa fa-fax"></i>{' '}
                            Fax
                          </th>
                          <td>{this.state.agency.Fax}</td>
                        </tr>
                        : ""
                    }
                    {
                      !!this.state.agency.SitioWeb ?
                        <tr>
                          <th scope="row">
                            <i className="fa fa-plus"></i>{' '}
                            Sitio Web
                          </th>
                          <td>{this.state.agency.SitioWeb}</td>
                        </tr>
                        : ""
                    }
                    {
                      !!this.state.agency.representante ?
                        <tr>
                          <th scope="row">
                            <i className="fa fa-plus"></i>{' '}
                            Representante Actual
                          </th>
                          <td>{this.state.agency.representante}</td>
                        </tr>
                        : ""
                    }
                    </tbody>
                  </Table>
                </Card>
              </div>
              <div className="col-sm-12 col-md-3">
                <Card body>
                  {imagen}
                </Card>
                <br></br>
                <Card body>
                  {foto}
                </Card>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default Agencias;
